import { removeConditionsTable } from "../objects/remove_Conditions_Table_function";
import setupConditionsUpdate from "../objects/set_up_conditions_update_function";

export const createConditionTableObject = (conditionsTable, adjustedNbrYearsCollege, newCareerID, 
        conditionList) => {
    let conditionClasses = ["career"];
    let newConditionsTable = conditionsTable;
    if (adjustedNbrYearsCollege === 0){
        newConditionsTable = removeConditionsTable(conditionsTable, "career");
        let newGameData={jobInfo: {careerID:  newCareerID }};
        let newCareerConditionsTable = 
            setupConditionsUpdate(newGameData, conditionList, conditionClasses);
        for (let i=0; i<newCareerConditionsTable.length; i++){
            newConditionsTable.push(newCareerConditionsTable[i]);
        }
    }else{
        let collegeCondition = 
            {condName: "in-college", conditionClass: "college"}
        newConditionsTable.push(collegeCondition);
    }
    return newConditionsTable;
}
export default createConditionTableObject;